module.exports = __webpack_public_path__ + "images/0ed87d9e2d7be74d0c57f54835b8894b.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/marina.jpg
// module id = 153
// module chunks = 24